export default "__VITE_ASSET__Bqc1hiNb__"